import { isNotNil } from "es-toolkit";
import WaveSurfer from "wavesurfer.js";
import Hover from "wavesurfer.js/dist/plugins/hover.esm.js";

interface SoundWaveOptions {
  peaks: number[][];
  duration: number;
  interactive?: boolean;
  listeners?: {
    onPlay?: () => void;
    onPause?: () => void;
    onFinish?: () => void;
  };
}

export function createSoundWave(selector: string, params: SoundWaveOptions) {
  const wavesurfer = WaveSurfer.create({
    peaks: params.peaks,
    duration: params.duration,
    container: selector,
    height: 40,
    normalize: true,
    waveColor: "#C7C7C7",
    progressColor: "#fff",
    cursorColor: "transparent",
    barWidth: 1,
    barGap: 1,
    barRadius: 3,
    hideScrollbar: true,

    autoplay: true, // NOTE: playing automatically after being created the audio instance.

    fetchParams: {
      mode: "no-cors",
    },
    interact: params.interactive === true,
    cursorWidth: params.interactive === true ? 2 : 0,
    plugins: [
      params.interactive === true
        ? Hover.create({
            lineColor: "#fff",
            lineWidth: 1,
            labelBackground: "#fff",
            labelColor: "#000",
            labelSize: "11px",
          })
        : null,
    ].filter(isNotNil),
  });

  wavesurfer.once("play", () => {
    params.listeners?.onPlay?.();
  });
  wavesurfer.once("interaction", () => {
    wavesurfer.play();
  });
  wavesurfer.once("pause", () => {
    params.listeners?.onPause?.();
  });
  wavesurfer.once("finish", () => {
    wavesurfer.setTime(0);
    params.listeners?.onFinish?.();
  });

  wavesurfer.once("destroy", () => {});

  return wavesurfer;
}
